import React from 'react';
import { autobind } from 'core-decorators';
import { FormattedMessage } from 'react-intl';
import { Row, Col } from 'reactstrap';

import InputNumber from 'src/componentes/input-number';
import Lookup from './lookup';
import { FormGroup } from 'src/componentes/Form';
import Input from 'src/componentes/input';

@autobind
class DesenharCampoCustomizado extends React.Component {
  static defaultProps = {
    colValue: null,
    mdFields: 3,
    heightFieldText: '33px',
    ignoreErrors: false,
    usarFiltroMultiSelecaoListaOpcao: false,
    shouldDisplayField: null,
    isRequiredField: null,
    isFieldEditable: null,
    showCharCount: false,
  };

  renderCharCount(value, limit) {
    if (!this.props.showCharCount || !limit) return null;

    const currentLength = (value || '').length;
    const overLimit = currentLength > limit;

    return (
      <div
        className={overLimit ? 'text-danger' : 'text-muted'}
        style={{ fontSize: '0.75rem', textAlign: 'right' }}
      >
        <span>
          {currentLength}/{limit}
        </span>
        {overLimit && (
          <div>
            <FormattedMessage
              id="labelReduzaCampoLimiteCaracteres"
              values={{ limite: limit }}
            />
          </div>
        )}
      </div>
    );
  }

  handleChange(index, item) {
    let itens = this.props.model.value;

    if (index !== -1) {
      itens[index].valor = item;
    }

    this.props.model.requestChange(itens);
  }

  handleLookupChange(index, item) {
    let itens = this.props.model.value;

    if (index !== -1) {
      itens[index].valor = item ? item.id : null;
    }

    this.props.model.requestChange(itens);
  }

  handleLookupChangeMulti(index, item) {
    let itens = this.props.model.value;
    if (index !== -1)
      itens[index].campo.valores = item.map((i) =>
        itens[index].campo.opcoesTabela.find((op) => op.id == i.id)
      );
    this.props.model.requestChange(itens);
  }

  isCampoCustomizadoSemValor(item) {
    const isMultiSelecao =
      item.campo.tipo.id === 5 &&
      (item.campo.multiSelecao || this.props.usarFiltroMultiSelecaoListaOpcao);

    if (isMultiSelecao) {
      return !item.campo.valores || item.campo.valores.length <= 0;
    }

    return (
      item.valor == null ||
      item.valor === '' ||
      (Array.isArray(item.valor) && item.valor.length === 0)
    );
  }

  desenharCampoCustomizado(
    item,
    index,
    desconsiderarObrigatorio,
    visibleFields,
    useVisibleFields
  ) {
    const visible = item.campo.visivel == null || item.campo.visivel;

    let required;
    if (this.props.isRequiredField) {
      required =
        this.props.isRequiredField(item.campo.id) && !desconsiderarObrigatorio;
    } else {
      required = item?.campo?.obrigatorio && !desconsiderarObrigatorio;
    }

    const errors =
      required &&
      !this.props.ignoreErrors &&
      this.isCampoCustomizadoSemValor(item);

    if (!visible) return;

    let disabled = this.props.customIsDisabledValidation
      ? this.props.customIsDisabledValidation(item)
      : this.props.disabled;

    if (this.props.isFieldEditable) {
      disabled = !this.props.isFieldEditable(item.campo.id);
    }

    const { maxLength } = this.props;

    const label = item.descricaoCampo ?? item.campo.nome;

    if (useVisibleFields && !visibleFields?.some((f) => f.id === item.idCampo))
      return;

    if (item.campo.tipo.id === 1) {
      const limit = maxLength ? maxLength : 3000;
      return (
        <FormGroup>
          <Input
            style={{ height: this.props.heightFieldText }}
            required={required}
            maxLength={limit}
            onBlur={this.props.getAlteracao}
            disabled={disabled}
            model={{
              errors: errors,
              value: item.valor,
              label: label,
              requestChange: this.handleChange.bind(this, index),
            }}
          />
          {this.renderCharCount(item.valor, limit)}
        </FormGroup>
      );
    }
    if (item.campo.tipo.id === 2) {
      const limit = maxLength ? maxLength : 5000;
      return (
        <FormGroup>
          <Input
            disabled={disabled}
            required={required}
            onBlur={this.props.getAlteracao}
            type="textarea"
            rows={this.props.rowsTextArea ? this.props.rowsTextArea : '2'}
            maxLength={limit}
            model={{
              errors: errors,
              value: item.valor,
              label: label,
              requestChange: this.handleChange.bind(this, index),
            }}
          />
          {this.renderCharCount(item.valor, limit)}
        </FormGroup>
      );
    }
    if (item.campo.tipo.id === 3) {
      return (
        <InputNumber
          style={{ height: '33px' }}
          required={required}
          onBlur={this.props.getAlteracao}
          precision={0}
          disabled={disabled}
          model={{
            errors: errors,
            value: item.valor,
            label: label,
            requestChange: this.handleChange.bind(this, index),
          }}
        />
      );
    }
    if (item.campo.tipo.id === 4) {
      return (
        <InputNumber
          style={{ height: '33px' }}
          required={required}
          onBlur={this.props.getAlteracao}
          precision={2}
          disabled={disabled}
          model={{
            errors: errors,
            value: item.valor,
            label: label,
            requestChange: this.handleChange.bind(this, index),
          }}
        />
      );
    }
    if (item.campo.tipo.id === 5) {
      if (
        item.campo.multiSelecao ||
        this.props.usarFiltroMultiSelecaoListaOpcao
      ) {
        return (
          <Lookup
            required={required}
            onBlur={this.props.getAlteracao}
            disabled={disabled}
            options={item.campo.opcoesTabela}
            multi
            multiValueWrapper={'max-width: 300px;'}
            model={{
              errors: errors,
              value:
                item.campo.valores &&
                item.campo.valores.map(({ id, descricao }) => ({
                  id,
                  descricao: <span title={descricao}>{descricao}</span>,
                })),
              label: label,
              requestChange: this.handleLookupChangeMulti.bind(this, index),
            }}
          />
        );
      } else {
        let value =
          item.campo.opcoesTabela &&
          item.campo.opcoesTabela.find((op) => op.id == item.valor)
            ? item.campo.opcoesTabela.find((op) => op.id == item.valor)
            : null;
        return (
          <Lookup
            required={required}
            onBlur={this.props.getAlteracao}
            disabled={disabled}
            options={item.campo.opcoesTabela}
            model={{
              errors: errors,
              value: value,
              label: label,
              requestChange: this.handleLookupChange.bind(this, index),
            }}
          />
        );
      }
    }
  }

  render() {
    let {
      model,
      colValue,
      desconsiderarObrigatorio,
      mdFields,
      mdFieldsTo,
      visibleFields = [],
      useVisibleFields = false,
    } = this.props;

    let fullList = model.value
      ? model.value.sort((a, b) => a.campo.ordem - b.campo.ordem)
      : [];

    let filteredLista = fullList;
    if (this.props.shouldDisplayField) {
      filteredLista = fullList.filter((item) =>
        this.props.shouldDisplayField(item.campo.id)
      );
    }

    if (filteredLista.length === 0) {
      return <div></div>;
    }

    return colValue ? (
      <Row>
        {filteredLista.map((item) => {
          const originalIndex = fullList.findIndex(
            (fullItem) => fullItem.campo.id === item.campo.id
          );
          return (
            <Col md={colValue} key={item.campo.id}>
              {this.desenharCampoCustomizado(
                item,
                originalIndex,
                desconsiderarObrigatorio,
                visibleFields,
                useVisibleFields
              )}
            </Col>
          );
        })}
      </Row>
    ) : (
      <Row>
        {filteredLista.map((item) => {
          const originalIndex = fullList.findIndex(
            (fullItem) => fullItem.campo.id === item.campo.id
          );
          return (
            <Col
              md={
                item.campo &&
                item.campo.tipo &&
                (item.campo.tipo.id == 1 || item.campo.tipo.id == 2) &&
                (!mdFieldsTo ||
                  mdFieldsTo.find((x) => x === item.campo.tipo.id))
                  ? 12
                  : mdFields
              }
              key={item.campo.id}
            >
              {this.desenharCampoCustomizado(
                item,
                originalIndex,
                desconsiderarObrigatorio,
                visibleFields,
                useVisibleFields
              )}
            </Col>
          );
        })}
      </Row>
    );
  }
}

export default DesenharCampoCustomizado;
